import FlowLayout from "components/layout/FlowLayout";
import "./RequestSystemAccess.scoped.scss";
import {Routes} from "components/routing/Routing";
import React, {useEffect,useState } from "react";
import {useDispatch} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {
  loadSystemAccessRequest,
  submitSystemAccessRequestApproval,
} from "store/userManagement/userManagementActions";
import useSelector from "store/useSelector";
import "../management/UserDetail.scoped.scss";
import ModalSpinner from "components/common/ModalSpinner";
import RoleAssignmentTable from "../RoleAssignmentTable";
import {AddRoleAssignmentService} from "../../../services/addRoleAssignmentService";
import {SystemAccessApprovalResponseTypes} from "../../../interfaces/user/UserInterfaces";

interface IViewSystemAccessRequestProps {

}

const ViewSystemAccessRequest: React.FC<IViewSystemAccessRequestProps> = (props) => {
  const {
    userManagement: {
      bulkEditUserData: {
        selectedUsers,
        roleAssignments,
        saveOperation,
        loadOperation,
        systemAccessRequestId,
        isDirty,
        systemAccessRequestReason
      }
    }
  } = useSelector(store => store);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {id: newId} = useParams();
  const urlId = newId!;
  const [decisionReason, setDecisionReason] = useState("");
  const [reasonTouched, setReasonTouched] = useState(false);
  const roleAssignmentService =
    new AddRoleAssignmentService(Routes.ViewSystemAccessRequestRoleAssignment.replace(":id", urlId), dispatch, navigate);

  useEffect(() => {
    const id = parseInt(urlId, 10);

    if (!isDirty
      && urlId
      && !isNaN(id)
      && id.toString() === urlId) {
      dispatch(loadSystemAccessRequest(id));
    }
  }, [dispatch, urlId, isDirty]);

  return (
    <FlowLayout
      header={(
        <div>
          <div className="toolbar">
            <h2 className="page-title">
              Approve/Reject System Access Request
              {selectedUsers &&
                selectedUsers.length > 0 &&
                <span> ({selectedUsers[0]?.name} - {selectedUsers[0]?.email})</span>}
            </h2>
            <div className="buttons">
              <button
                disabled={!systemAccessRequestId}
                className="primary-button tool-button"
                onClick={() =>
                  dispatch(submitSystemAccessRequestApproval(
                    {
                      approvalData: {
                        userEmail: selectedUsers[0].email,
                        systemAccessRequestId: Number(systemAccessRequestId),
                        approvalResponse: SystemAccessApprovalResponseTypes.Approved,
                        roleAssignments: roleAssignments ?? [],
                        decisionReason: decisionReason.trim() || undefined,
                      },
                      navigate: navigate
                    }))
                }
              >
                Approve
              </button>
              <button
                disabled={!systemAccessRequestId}
                className="secondary-button tool-button"
                onClick={() => {
                  setReasonTouched(true);
                  if (!decisionReason.trim()) return;
                  dispatch(submitSystemAccessRequestApproval(
                    {
                      approvalData: {
                        userEmail: selectedUsers[0].email,
                        systemAccessRequestId: Number(systemAccessRequestId),
                        approvalResponse: SystemAccessApprovalResponseTypes.Rejected,
                        roleAssignments: [],
                        decisionReason: decisionReason.trim(),
                      },
                      navigate: navigate
                    }));
                }}
              >
                Reject
              </button>
            </div>
          </div>
          <p className="instructions">Click "Add Role Assignment" to include additional access permissions to this request. </p>
          {systemAccessRequestReason && (
            <div className="reason-field read-only-reason">
              <label>Requester's Reason for Access</label>
              <p className="reason-display">{systemAccessRequestReason}</p>
            </div>
          )}
          <div className="reason-field">
            <label htmlFor="decisionReason">Reason / Comments {<span className="required">*</span>}</label>
            <textarea
              id="decisionReason"
              className={reasonTouched && !decisionReason.trim() ? "error" : ""}
              placeholder="Provide a reason for rejection (required) or additional comments for approval (optional)..."
              value={decisionReason}
              maxLength={2000}
              rows={3}
              onChange={(e) => setDecisionReason(e.target.value)}
              onBlur={() => setReasonTouched(true)}
            />
            {reasonTouched && !decisionReason.trim() && (
              <span className="error-message">Reason is required when rejecting a request.</span>
            )}
          </div>
        </div>
      )}
      footer={
        <div className="footer-wrapper">
          <div className="add-role-assignment-button-wrapper">
            <button
              disabled={!systemAccessRequestId}
              className="primary-button add-role-assignment-button"
              onClick={() => { roleAssignmentService.onAddRoleAssignment() }}
            >
              Add Role Assignment
            </button>
          </div>
        </div>
      }
    >
      {(loadOperation?.isWorking || saveOperation?.isWorking) &&
        <ModalSpinner />
      }
      {roleAssignments
        && roleAssignments.length > 0
        &&
        <RoleAssignmentTable
          roleAssignments={roleAssignments}
          roleAssignmentService={roleAssignmentService}
        />
      }
    </FlowLayout>
  );
}

export default ViewSystemAccessRequest;